export default {"src":"/_next/static/media/gray-grid.f0acded4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};